/**
 * Validation Utilities
 *
 * Pure functions for input validation.
 */

/**
 * Validate an email address format.
 *
 * @param {string} email - Email address to validate
 * @returns {boolean}
 */
export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
